import {Spacing} from '../../../Styles';
import {ThemedStyleSheet} from '../../../Utils/ThemedStyleSheet';

export default ThemedStyleSheet((theme) => ({
  container: {
    paddingTop: Spacing.medium,
    paddingBottom: Spacing.small,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  title: {
    flex: 1,
    textAlign: 'left',
    color: theme.colors.textStrong,
    fontSize: 25,
    lineHeight: 31,
    fontWeight: '700',
  },
  titleActions: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: Spacing.xsmall,
  },
  titleIconButton: {
    width: 40,
    height: 40,
    borderRadius: 8,
    margin: 0,
    marginLeft: Spacing.xxsmall,
  },
  subtitle: {
    textAlign: 'left',
    marginTop: Spacing.xsmall,
    color: theme.colors.textLight,
    fontSize: 16,
    lineHeight: 24,
  },

  options: {
    marginTop: Spacing.small,
  },
  optionRowWrap: {
    marginBottom: Spacing.xsmall,
  },
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surface,
    paddingVertical: 13,
    paddingHorizontal: Spacing.small,
  },
  optionRowSelected: {
    borderColor: theme.colors.primary,
    borderWidth: 2,
    backgroundColor: theme.colors.surfaceSecondary,
  },
  optionIndicator: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: theme.colors.placeholder,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.surface,
  },
  optionIndicatorSelected: {
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.primary,
  },
  optionIndicatorDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: theme.colors.textContrast,
  },
  optionLabel: {
    flex: 1,
    marginLeft: Spacing.small,
    color: theme.colors.textStrong,
  },
  optionLabelSelected: {
    color: theme.colors.primary,
  },
}));
